import { Component, Inject, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { CustomerServiceService } from "../customer-service.service";

@Component({
  selector: "app-delete-account",
  templateUrl: "./delete-account.component.html",
  styleUrls: ["./delete-account.component.css"],
})
export class DeleteAccountComponent implements OnInit {
  deleteData: any;
  token: any;
  constructor(
    @Inject(MAT_DIALOG_DATA) data: any,
    private matDialogRef: MatDialogRef<DeleteAccountComponent>,
    private services: CustomerServiceService,
    private router: Router,
    private snackBar: MatSnackBar
  ) {
    this.deleteData = data;
  }

  ngOnInit(): void {
    this.token = sessionStorage.getItem("token");
  }
  backProfile() {
    this.matDialogRef.close();
  }
  deleteAccount() {
    const userType = "inactive";
    this.services
      .accountDelete(userType, this.deleteData, this.token)
      .subscribe(
        (response: any) => {
          if (response.status == 200) {
            this.matDialogRef.close();
            this.router.navigateByUrl("/");
            localStorage.clear();
            this.snackBar.open(
              "Your account has been deleted successfully",
              "Success",
              {
                duration: 5000,
              }
            );
          }
        },
        (error) => {
          this.snackBar.open(error.error.message, "Fail", {
            duration: 5000,
          });
          if (error.error.message === "jwt expired") {
            this.router.navigateByUrl("/");
            localStorage.clear();
          }
          if (error.error.message === "jwt malformed") {
            this.router.navigateByUrl("/");
            localStorage.clear();
          }
          return;
        }
      );
  }
}
